var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconMinimize = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M10.7,5.3v3.3c0,1.2-1,2.2-2.2,2.2H5.3 M24.8,10.7h-3.3c-1.2,0-2.2-1-2.2-2.2V5.3\n\t M19.3,24.8v-3.3c0-1.2,1-2.2,2.2-2.2h3.3 M5.3,19.3h3.3c1.2,0,2.2,1,2.2,2.2v3.3" }))));
});
export default IconMinimize;
//# sourceMappingURL=IconMinimize.js.map